import * as React from "react";
import { RootState } from "../../redux";
import Scroll from "../../components/Scroll";
import { connect, Dispatch } from "react-redux";
import { IChatNormalized } from "../../types/index";
import { selectChat } from "../../redux/modules/ui/ui";
import ChatListItem from "../../components/ChatList/Item";
import { markAsRead } from "../../redux/modules/appChats/appChats";

const s = require("./ChatList.scss");

interface IChatListProps {
    chats: IChatNormalized[];
    selectedChat?: string;
    dispatch?: Dispatch<any>;
};

interface IChatListState {};

class ChatList extends React.Component<IChatListProps, IChatListState> {
    onChatItemClick(e: React.MouseEvent<HTMLDivElement>, id: string) {
        this.props.dispatch(selectChat(id));
        this.props.dispatch(markAsRead(id));
    }

    public render(): JSX.Element {
        const chats = this.props.chats.map(chat => {
            return (
                <ChatListItem
                    key={chat.id}
                    chat={chat}
                    onClick={this.onChatItemClick.bind(this)}
                    active={this.props.selectedChat === chat.id}
                />
            );
        });

        return (
            <div className={s.chatList}>
                <Scroll>
                    {chats}
                </Scroll>
            </div>
        );
    }
}

export default connect((state: RootState) => {
    let obj: IChatListProps = {
        chats: state.entities.chats.allIds.map(chatId => {
            let chat = state.entities.chats.byId[chatId];

            return Object.assign({}, chat, {
                lastMessage: state.entities.messages.byId[chat.lastMessageId]
            }) as IChatNormalized;
        })
    };

    obj.selectedChat = state.ui.chats.selected;

    return obj;
})(ChatList);



// WEBPACK FOOTER //
// ./src/containers/ChatList/index.tsx